import React, { memo } from 'react';
import { AlertCircle } from '@saleshandy/icons';
import Modal from '../../../../../../../shared/design-system/components/atoms/modal';
import { AiSeqCloseConfirmationModalProps } from '../../../type';

/**
 *
 * @description
 * A confirmation modal shown when the user attempts to close the AI Sequence Generator.
 * It warns the user that unsaved progress will be lost and gives them the option to either discard the changes
 * or proceed with generating a sequence based on the entered data.
 *
 * @param show - Controls the visibility of the modal.
 * @param onDiscardSequence - Called when the user confirms they want to discard the changes.
 * @param onResumingProcess - Called when the user confirms they want to proceed with generating a sequence.
 *
 * @returns React Component
 * */

const AiSeqCloseConfirmationModal: React.FC<AiSeqCloseConfirmationModalProps> = ({
  show = false,
  onDiscardSequence = () => {},
  onResumingProcess = () => {},
}) => (
  <Modal
    show={show}
    onHide={() => {}}
    hideHeader
    onCancel={onDiscardSequence}
    onSubmit={onResumingProcess}
    submitButtonText="Continue Setup"
    cancelButtonText="Discard Journey"
    className="ai-seq-close-confirmation-modal"
    submitButtonClassName="ai-seq-close-modal-confirm-btn"
    cancelButtonClassName="ai-seq-close-modal-discard-btn"
  >
    <div className="close-modal-conatiner">
      <div className="close-modal-header">
        <AlertCircle width={24} height={24} color="#D97706" />
        <span>You’re about to close the AI Sequence Generator.</span>
      </div>
      <div className="close-modal-text">
        <span>Any unsaved progress will be lost.</span>
        <br />
        <span>
          Would you like to create a Email sequence with the details you've
          already entered so far?
        </span>
      </div>
    </div>
  </Modal>
);
export default memo(AiSeqCloseConfirmationModal);
